
import * as angular from "angular";

export class FullScreenService {
    document: any;

    static $inject = ["$rootScope", "$document"];

    constructor(
        private $rootScope: angular.IRootScopeService,
        private $document: angular.IDocumentService) {
        this.document = $document[0];
    }

    all() {
        this.enable(this.document.documentElement);
    }

    toggle(el: Element): boolean {

        if (this.isEnabled()) {
            this.cancel();
            return false;
        }

        this.enable(el);
        return true;
    }

    enable(el: Element) {

        var element = el as any;

        if (element.requestFullscreen) {
            element.requestFullscreen();
        }
        else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        }
        else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
        else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }

    cancel() {
        if (this.document.cancelFullScreen) {
            this.document.cancelFullScreen();
        }
        else if (this.document.mozCancelFullScreen) {
            this.document.mozCancelFullScreen();
        }
        else if (this.document.webkitExitFullscreen) {
            this.document.webkitExitFullscreen();
        }
        else if (this.document.msExitFullscreen) {
            this.document.msExitFullscreen();
        }
    }

    isEnabled() {
        const fullscreenElement = this.document.fullscreenElement || this.document.mozFullScreenElement || this.document.webkitFullscreenElement || this.document.msFullscreenElement;
        return fullscreenElement ? true : false;
    }

    toggleAll() {
        this.isEnabled() ? this.cancel() : this.all();
    }

    isSupported() {
        const docElm = this.document.documentElement;
        const requestFullscreen = docElm.requestFullScreen || docElm.mozRequestFullScreen || docElm.webkitRequestFullscreen || docElm.msRequestFullscreen;

        return requestFullscreen ? true : false;
    }
}
